module.exports = __webpack_public_path__ + "assets/img/http.813cd5ea.svg";